module.exports = __webpack_public_path__ + "img/FR.02c7b0f8.webp";